<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.file-manager.text") }}</h1>

      <div role="tablist">
        <b-card no-body class=" shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.file-manager.line-1") }}
            </p>

            <p>{{ $t("help.platform.file-manager.line-2") }}</p>
            <p>{{ $t("help.platform.file-manager.line-3") }}</p>
          </b-card-body>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.file-manager.screen.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.file-manager.screen.line-1") }}
              </p>

              <img src="@/assets/images/help/file-manager.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.file-manager.screen.line-2") }}
              </p>
              <img src="@/assets/images/help/asset-group-library-item.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.file-manager.screen.line-3") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.file-manager.screen.line-4") }}
              </p>

              <ul>
                <li>
                  <p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.screen.line-5')"></p>
                </li>
                <li>
                  <p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.screen.line-6')"></p>
                </li>
              </ul>

              <p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.screen.line-7')"></p>

              <p class="mt-3 mb-3">
                {{ $t("help.platform.file-manager.screen.line-8") }}
              </p>

              <ul class="mt-3 mb-3">
                <li>
                  <p>
                    {{ $t("help.platform.file-manager.screen.line-9") }}
                  </p>
                </li>
                <li>
                  <p>
                    {{ $t("help.platform.file-manager.screen.line-10") }}
                  </p>
                </li>
                <li>
                  <p>
                    {{ $t("help.platform.file-manager.screen.line-11") }}
                  </p>
                </li>
                <li>
                  <p>
                    {{ $t("help.platform.file-manager.screen.line-12") }}
                  </p>
                </li>
                <li>
                  <p>
                    {{ $t("help.platform.file-manager.screen.line-13") }}
                  </p>
                </li>
                <li>
                  <p>
                    {{ $t("help.platform.file-manager.screen.line-14") }}
                  </p>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>{{ $t("help.platform.file-manager.save.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.file-manager.save.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/file-upload-modal-2.png" class="image" />

              <p class="mt-3">{{ $t("help.platform.file-manager.save.line-2") }}</p>

              <ul>
                <li>
                  <p v-html="$t('help.platform.file-manager.save.line-3')"></p>
                  <ul>
                    <li>
                      <p v-html="$t('help.platform.file-manager.save.line-4')"></p>
                    </li>
                    <li>
                      <p v-html="$t('help.platform.file-manager.save.line-5')"></p>
                    </li>
                  </ul>
                </li>
                <li>
                  <p v-html="$t('help.platform.file-manager.save.line-6')"></p>
                </li>
                <li>
                  <p v-html="$t('help.platform.file-manager.save.line-7')"></p>
                </li>
                <li>
                  <p v-html="$t('help.platform.file-manager.save.line-8')"></p>
                </li>
              </ul>
              <p class="mt-3">{{ $t("help.platform.file-manager.save.line-9") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.save.line-10") }}</p>
              <img src="@/assets/images/help/file-manager-diff.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.save.line-11") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col3' ? 'founded' : ''" v-b-toggle.col3>
              <div>{{ $t("help.platform.file-manager.upload.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col3" :visible="col == 'col3'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.file-manager.upload.line-1") }}
              </p>
              <img src="@/assets/images/help/file-manager-button.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.upload.line-2") }}</p>
              <img src="@/assets/images/help/file-upload-form.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.upload.line-3") }}</p>

              <ul>
                <li>
                  <p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-4')"></p>
                  <ul>
                    <li>
                      <p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-5')"></p>
                    </li>
                    <li><p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-6')"></p></li>
                  </ul>
                </li>

                <li><p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-7')"></p></li>
                <li><p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-8')"></p></li>
                <li><p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-9')"></p></li>
                <li><p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-10')"></p></li>
                <li><p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-11')"></p></li>
                <li><p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-12')"></p></li>
                <li><p class="mt-3 mb-3" v-html="$t('help.platform.file-manager.upload.line-13')"></p></li>
              </ul>
              <p class="mb-3">
                {{ $t("help.platform.file-manager.upload.line-14") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
              <div>{{ $t("help.platform.file-manager.acl.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.file-manager.acl.line-1") }}
              </p>
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.acl.line-2") }}</p>
              <img src="@/assets/images/help/file-acl.png" class="image" />

              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.acl.line-3") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col5' ? 'founded' : ''" v-b-toggle.col5>
              <div>{{ $t("help.platform.file-manager.version.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col5" :visible="col == 'col5'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.file-manager.version.line-1") }}
              </p>
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.version.line-2") }}</p>
              <img src="@/assets/images/help/file-version.png" class="image" />

              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.version.line-3") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col5' ? 'founded' : ''" v-b-toggle.col5>
              <div>{{ $t("help.platform.file-manager.edit.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col5" :visible="col == 'col5'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.file-manager.edit.line-1") }}
              </p>

              <img src="@/assets/images/help/file-edit.png" class="image" />

              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.edit.line-2") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col6' ? 'founded' : ''" v-b-toggle.col6>
              <div>{{ $t("help.platform.file-manager.approval.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col6" :visible="col == 'col6'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.file-manager.approval.line-1") }}
              </p>
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-2") }}</p>

              <img src="@/assets/images/help/file-manager-2.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-3") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-4") }}</p>
              <img src="@/assets/images/help/pending-approval-file.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-5") }}</p>
              <img src="@/assets/images/help/file-approval-survey.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-6") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-7") }}</p>
              <img src="@/assets/images/help/file-approval-survey-member.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-8") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-9") }}</p>
              <img src="@/assets/images/help/question-set-file.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-10") }}</p>

              <ul>
                <li>
                  <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-11") }}</p>
                </li>
                <li>
                  <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-12") }}</p>
                </li>
              </ul>
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-13") }}</p>
              <img src="@/assets/images/help/file-approval-survey-result.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-14") }}</p>
              <img src="@/assets/images/help/file-approval-survey-2.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval.line-15") }}</p>
              <img src="@/assets/images/help/file-approval-survey-result-2.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col7' ? 'founded' : ''" v-b-toggle.col7>
              <div>{{ $t("help.platform.file-manager.approval-history.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col7" :visible="col == 'col7'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.file-manager.approval-history.line-1") }}
              </p>
              <img src="@/assets/images/help/file-approval-history.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval-history.line-2") }}</p>

              <p class="mt-3 mb-3">{{ $t("help.platform.file-manager.approval-history.line-3") }}</p>
              <img src="@/assets/images/help/completed-file-approval-survey.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
